import React, { useEffect, useState } from "react";
import * as cls from "./extAuth.module.scss";
import { useDispatch, useSelector } from "react-redux";
import authImg from "../../resources/images/authorization.png";
import { useNavigate } from "react-router-dom";
import {
  assignAction,
  resetStore,
  setInvalidLoginAction,
  setTokenAction,
} from "../../redux/actions/actions";
import { AuthorizationService } from "../authorizationService";
export default function Extauth({ appRoot }) {
  const searchParams = new URLSearchParams(window.location.search);
  let paramsToken = searchParams.get("token");

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (paramsToken) {
      dispatch(resetStore());
      dispatch(
        setTokenAction({ access_token: paramsToken, refresh_token: "" })
      );
      localStorage.setItem(
        "personalStudioAccessToken",
        JSON.stringify(paramsToken)
      );
      console.log("appRoot Extauth", appRoot);
      console.log("https://" + window.location.hostname + appRoot);
      window.location.href = "https://" + window.location.hostname + appRoot;
    }
  }, [paramsToken]);
  return (
    <>
      {!paramsToken && (
        <div
          onLoad={() => {
            console.log(
              "onload",
              "https://" + window.location.hostname + appRoot
            );
            window.location.href =
              "https://" + window.location.hostname + appRoot;
          }}
        ></div>
      )}
    </>
  );
}
